var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 100,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273.234 313.639H228.467C228.35 307.202 228.292 303.282 228.292 301.877C228.292 287.364 230.691 275.427 235.49 266.063C240.288 256.7 249.885 246.167 264.281 234.463C278.677 222.759 287.279 215.093 290.088 211.465C294.418 205.73 296.583 199.41 296.583 192.505C296.583 182.908 292.721 174.715 284.997 167.927C277.389 161.022 267.09 157.569 254.099 157.569C241.576 157.569 231.101 161.139 222.674 168.278C214.247 175.418 208.454 186.302 205.294 200.932L160 195.314C161.287 174.364 170.182 156.574 186.685 141.945C203.304 127.315 225.073 120 251.992 120C280.315 120 302.845 127.432 319.581 142.296C336.318 157.043 344.686 174.247 344.686 193.91C344.686 204.794 341.585 215.093 335.382 224.808C329.296 234.522 316.187 247.747 296.057 264.483C285.64 273.144 279.145 280.108 276.57 285.375C274.112 290.641 273 300.063 273.234 313.639ZM228.467 380V330.668H277.799V380H228.467Z",
    fill: "#008393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.f48e45857e4a6b33c26c2d27030e85c0.svg";
export { ForwardRef as ReactComponent };